import Swal from 'sweetalert2';
import {Language} from '../context/LanguageContext';
import Cookies from 'js-cookie';
// import {destroyCookie} from 'nookies';
import {useNavigate} from 'react-router-dom';
export const useNotification = () => {
  const {language, newObj} = Language();
  const navigate = useNavigate();
  const notificationHandler = (code, message, isSwal = true) => {
    switch (code) {
      case 200:
      case 201:
        if (!isSwal) return;
        return Swal.fire({
          icon: 'success',
          title: newObj.SuccessWord[language],
          text: message,
        });
      case 400:
      case 500:
        return Swal.fire({
          icon: 'error',
          title: newObj.ErrorWord[language],
          text: message,
        });
      case 401:
        Cookies.remove('token');
        // destroyCookie(null, 'token');
        navigate('/login');
        return Swal.fire({
          icon: 'error',
          title: newObj.ErrorWord[language],
          text: message,
        });
      default:
        return;
    }
  };
  return {
    notificationHandler,
  };
};
